import { render } from "./JingJi.vue?vue&type=template&id=bcfb477e&scoped=true"
import script from "./JingJi.vue?vue&type=script&lang=js"
export * from "./JingJi.vue?vue&type=script&lang=js"

import "./JingJi.vue?vue&type=style&index=0&id=bcfb477e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcfb477e"]])

export default __exports__